import { Box } from "@mui/material";
import { Navbar } from "../organisms/Navbar";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProfileMenu } from "../organisms/ProfileMenu";
import { FastViews } from "../../features/fastViews";
// import { Plan } from "../../features/plan";
import { ApiKeys } from "../../features/api-keys";
import MenuIcon from "@mui/icons-material/Menu";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { authStore } from "../../features/auth/store/AuthStore";
import { Prices } from "../../features/prices";
import { Levels } from "../../features/levels";
import { Settings } from "../../features/settings";
import { ReplenishmentsList } from "../../features/replenishments";
import { ExpensesList } from "../../features/expenses";

export const MainTemplate = observer(() => {
  const { toggleMenu } = useContext(authStore);
  return (
    <Box component={"main"} sx={{ display: "flex" }}>
      <Navbar />
      <Box
        sx={{
          flex: "1",
          px: { xs: "12px", sm: "12px", md: "24px" },
          // minWidth: "640px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: {
              xs: "space-between",
              sm: "space-between",
              md: "end",
            },
            height: "64px",
            backgroundColor: "#ffff",
            alignItems: "center",
          }}
        >
          <MenuIcon
            sx={{
              color: "#666666",
              cursor: "pointer",
              display: { xs: "block", sm: "block", md: "none" },
            }}
            fontSize="large"
            onClick={() => toggleMenu(true)}
          />

          <ProfileMenu />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Routes>
            <Route path="/fast-views/orders" element={<FastViews />} />
            {/* <Route path="/fast-views/plan" element={<Plan />} /> */}
            <Route path="/fast-views/prices" element={<Prices />} />
            <Route path="/account" element={<Levels />} />
            <Route path="/fast-views/api-keys" element={<ApiKeys />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/replenishments" element={<ReplenishmentsList />} />
            <Route path="/expenses" element={<ExpensesList />} />
            <Route
              path="*"
              element={<Navigate to="/fast-views/orders" replace />}
            />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
});
